export default __webpack_public_path__ + "static/media/logo-02.da27cc36.png";